import * as React from "react";
import Svg, { Rect, G, Path, Defs, ClipPath } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Rect width={42} height={42} rx={4.2} fill={props.bgColor || "#F3FAF6"} />
    <G clipPath="url(#clip0_997_4624)">
      <Path
        opacity={0.2}
        d="M12.1079 13.8302H28.1696C28.5569 13.8302 28.9283 13.984 29.2021 14.2579C29.4759 14.5317 29.6298 14.9031 29.6298 15.2904V28.4318H12.1079V13.8302Z"
        fill={props.color || "#0E8741"}
      />
      <Path
        d="M29.6298 28.4318H12.1079V13.8302"
        stroke={props.color || "#0E8741"}
        strokeWidth={1.46016}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M29.6298 18.2107L23.7892 23.3212L17.9485 18.9408L12.1079 24.0513"
        stroke={props.color || "#0E8741"}
        strokeWidth={1.46016}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_997_4624">
        <Rect
          width={23.3625}
          height={23.3625}
          fill="white"
          transform="translate(9.1875 9.44995)"
        />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
